<script>
import { h, resolveComponent } from 'vue';

export default {
  name: 'cRowList',
  data() {
    return {
      newValue: {},
      cuskey: 0
    };
  },
  emits: ['addRow', 'removeRow'],
  props: {
    value: {
      type: Array,
      default: null
    },
    headers: {
      type: Array,
      default: () => {}
    },
    alertMsg: {
      type: String,
      default: ''
    },
    actionBtn: {
      type: Boolean,
      default: false
    },
    addRowForm: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.setDefault();
  },
  computed: {
    initItems() {
      const addRow = [this.newValue, ...this.value];
      return this.addRowForm ? addRow : this.value;
    }
  },
  methods: {
    setDefault() {
      for (let i = 0; i < this.headers.length; ++i) {
        this.newValue[i] = this.headers[i];
      }
      this.cuskey = this.cuskey + 1;
    },
    addRow() {
      this.$emit('addRow', this.newValue);
      this.newValue = {};
      this.setDefault();
      this.cuskey = 0;
    },
    removeRow(item) {
      this.$emit('removeRow', item);
    },
    onInput(e, index, val) {
      if (this.addRowForm) {
        if (index === 0) {
          Object.assign(this.newValue, { [val]: e });
        } else {
          Object.assign(this.value[index - 1], { [val]: e });
        }
      } else {
        Object.assign(this.value[index], { [val]: e });
      }
    }
  },
  render() {
    const { addRowForm, actionBtn, headers, initItems, $theme, alertMsg, cuskey } = this;
    const legoDropdown = resolveComponent('lego-dropdown');
    const legoTextField = resolveComponent('lego-text-field');
    const cLabel = resolveComponent('c-label');
    const legoIcon = resolveComponent('lego-icon');
    const legoTooltip = resolveComponent('lego-tooltip');
    const fieldType = (bidx, header, item) => {
      return header.type === 'dropdown'
        ? h(legoDropdown, {
            md: true,
            disabled: header.disabled && header.disabled(item[header.value], bidx),
            items: header.items,
            modelValue: item[header.value],
            placeholder: header.placeholder,
            'onUpdate:modelValue': (e) => this.onInput(e, bidx, header.value)
          })
        : h(legoTextField, {
            md: true,
            disabled: header.disabled && header.disabled(item[header.value], bidx),
            modelValue: item[header.value],
            placeholder: header.placeholder,
            rules: header.validate && header.validate(bidx),
            counter: header.maxLength,
            'onUpdate:modelValue': (e) => this.onInput(e, bidx, header.value)
          });
    };

    const rowListHeader = h(
      'div',
      {
        class: 'c-row-list-header'
      },
      [
        headers.map((header) => {
          return h(
            'div',
            {
              class: 'c-row-list-header__item',
              style: {
                width: header.width || '100%',
                flex: header.width ? `0 0 ${header.width}` : '100%'
              }
            },
            [
              h(
                cLabel,
                {
                  weight: 400,
                  inline: true,
                  ellipsis: true,
                  required: header.required,
                  color: $theme.COLOR.UI.UI02
                },
                [header.text]
              ),
              header.help &&
                h('span', { class: 'help' }, [
                  h(legoIcon, {
                    iconType: 'df',
                    icon: 'info',
                    size: 16,
                    id: 'manual'
                  }),
                  h(legoTooltip, { top: true, mouseOver: true }, [header.help])
                ])
            ]
          );
        })
      ]
    );
    const legoIconButton = resolveComponent('lego-icon-button');
    const itemList = initItems.map((item, bidx) =>
      h(
        'div',
        {
          key: addRowForm && bidx == 0 ? cuskey : `row-${bidx}`,
          class: 'c-row-list-body__row'
        },
        [
          headers.map((header) => {
            return h(
              'div',
              {
                class: 'c-row-list-body__item',
                style: {
                  width: header.width || '100%',
                  flex: header.width ? `0 0 ${header.width}` : '100%'
                }
              },
              [
                this.$slots.items
                  ? this.$slots.items({
                      item: item[header.value],
                      header: header,
                      index: bidx
                    })
                  : fieldType(bidx, header, item)
              ]
            );
          }),
          h(
            'div',
            {
              class: 'c-row-list-body__action',
              style: {
                width: '32px',
                flex: `0 0 32px`
              }
            },
            [
              (actionBtn || addRowForm) &&
                bidx === 0 &&
                h(legoIconButton, {
                  iconType: 'df',
                  icon: 'add_border',
                  size: 32,
                  border: true,
                  md: true,
                  onClick: () => this.addRow(item)
                }),
              (actionBtn || addRowForm) &&
                bidx > 0 &&
                h(legoIconButton, {
                  iconType: 'df',
                  icon: 'eliminate_border',
                  size: 32,
                  border: true,
                  md: true,
                  onClick: () => this.removeRow(item)
                })
            ]
          )
        ]
      )
    );

    const rowListBody = h(
      'div',
      {
        class: 'c-row-list-body'
      },
      [
        itemList,
        alertMsg &&
          h(
            'div',
            {
              class: {
                'alert-msg': true
              }
            },
            [
              h(legoIcon, {
                iconType: 'df',
                icon: 'warning',
                size: 16
              }),
              alertMsg
            ]
          )
      ]
    );

    return h(
      'div',
      {
        class: {
          'c-row-list': true
        }
      },
      [rowListHeader, rowListBody]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-row-list {
  :deep(.lego-text-field__counter) {
    display: none;
  }

  &-header {
    display: flex;
    align-items: center;

    &__item {
      margin: 12px 4px;

      .help {
        position: relative;
        top: 2px;
        left: 2px;
      }
    }
  }

  &-body {
    &__row {
      width: 100%;
      display: flex;
      align-items: center;
      margin-bottom: 8px;
    }

    &__item {
      display: flex;
      align-items: center;
      margin: 0 4px;

      .lego-text-field,
      .lego-dropdown {
        min-width: 100%;
      }

      .lego-button {
        width: 62px;
        flex: 0 0 62px;
        margin-left: 8px;
      }
    }

    .alert-msg {
      display: flex;
      align-items: center;
      color: $color--status--error;
      margin-top: 10px;

      :deep(.lego-icon) {
        margin-right: 5px;
      }
    }
  }
}
</style>
